module.exports = __webpack_public_path__ + "img/pin.3b3d579.svg";